import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Switch, Route, useLocation, useRouteMatch } from 'react-router-dom';

import ViewTitle from '../../common/view-title';
import Loader from '../../common/loader';
import NotFound from '../../common/not-found';

import EmployeePayBiweeklyMenu from './employee-pay-biweekly-menu';
import EmployeePayBiweeklyDetail from './employee-pay-biweekly-detail';
import EmployeePayBiweeklyIndex from './employee-pay-biweekly-index';

import helpers from '../../utils/helpers';

const useStyles = makeStyles(() => ({
    root: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
    }
}));

const EmployeePayBiweekly = () => {

    const classes = useStyles();
    const { pathname } = useLocation();
    const { path } = useRouteMatch();
    const [state, setState] = useState({
        loading: true,
        permissions: {}
    });

    useEffect(() => {
        const validatePermissions = () => {
            const permissions = helpers.getPermissions(pathname);
            setState(prev => ({ ...prev, permissions, loading: false }));
        }

        validatePermissions();
    }, []);

    if (state.loading) {
        return <Loader />;
    }

    if (!state.permissions?.read_attr) {
        return <NotFound />;
    }

    return (
        <div className={classes.root}>
            <ViewTitle sedeFlag title='Employee payment biweekly' />

            <Switch>
                <Route exact path={path}><EmployeePayBiweeklyMenu permissions={state.permissions} /></Route>
                <Route exact path={`${path}/index`}><EmployeePayBiweeklyIndex permissions={state.permissions} /></Route>
                <Route exact path={`${path}/:id`}><EmployeePayBiweeklyDetail permissions={state.permissions} /></Route>
                <Route path={`${path}/*`}><NotFound /></Route>
            </Switch>
        </div>
    );
}

export default EmployeePayBiweekly;